import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-header justify-content-center mt-2" }
const _hoisted_2 = { class: "confirmation-modal-title" }
const _hoisted_3 = { class: "modal-body mx-4 mt-2" }
const _hoisted_4 = { class: "confirmation-modal-note" }
const _hoisted_5 = { class: "d-flex justify-content-end m-3 mt-4" }

import unexpectedEventsAndLongTimeContinuousDrivingExtensions from "src/types/responses/unexpectedEventsAndLongTimeContinuousDrivingExtensions";
import ModalFlashMessage from "@/components/Common/ModalFlashMessage.vue";
import { useAuth } from "@/services/user/Auth0UserProvider";
import Api from "@/services/api/ApiServiceFabrick";
import { ref, reactive, computed } from 'vue';
import { GDialog } from 'gitart-vue-dialog';
import i18n from '@/lang/i18n';

type flashMessagesType = {
  message: string,
  show: boolean,
  type: string,
  cancel: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteModal',
  props: {
    deleteItem: {},
    getUnexpectedEventAndLongTimeDrivingExtensions: { type: Function },
    modelValue: { type: Boolean },
    showFlash: { type: Function }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

const flashMessage = reactive({
  message: "",
  show: false,
  type: "info",
  cancel: false
}) as flashMessagesType

const { loginWithRedirect } = useAuth()
const isLoading = ref(false)

const isUnexpectedEvents = computed(() => {
  return props.deleteItem.division_name == 'unexpected_events'
})

const confirmMessage = computed(() => {
  if (isUnexpectedEvents.value) return i18n.global.t('pages.unexpectedEventAndAlertStatuses.deleteModal.unexpectedEvent.note')
  return i18n.global.t('pages.unexpectedEventAndAlertStatuses.deleteModal.longTimeContinuousDrivingExtension.note')
})

function closeModal(isDeleted: boolean) {
  if (isDeleted) props.getUnexpectedEventAndLongTimeDrivingExtensions()
  modelValue.value = false
}

function handleDelete() {
  isLoading.value = true
  if (isUnexpectedEvents.value) return deleteUnexpectedEvent()
  return deleteLongTimeContinuousDrivingExtension()
}

function deleteUnexpectedEvent() {
  Api().deleteUnexpectedEvent(props.deleteItem.id).then(() => {
    successDelete()
  }).catch((error: any) => {
    isLoading.value = false
    return errorHandle(error.response)
  })
}

function deleteLongTimeContinuousDrivingExtension() {
  Api().deleteLongTimeContinuousAlerts(props.deleteItem.id).then(() => {
    successDelete()
  }).catch((error: any) => {
    isLoading.value = false
    return errorHandle(error.response)
  })
}

function successDelete() {
  props.showFlash(i18n.global.t('pages.common.messages.removeSuccess'), "success", true)
  closeModal(true)
}

function changeFlashMessages(resultStatus = "", message = "") {
  flashMessage.type = resultStatus
  flashMessage.show = true
  flashMessage.cancel = false
  flashMessage.message = message

  if (resultStatus == "error") return flashMessage.cancel = true
}

function errorHandle (res: any) {
  switch (res.status) {
    case 401:
      loginWithRedirect({ appState: { targetUrl: location.pathname } })
      break
    case 403:
      changeFlashMessages("error", i18n.global.t('pages.common.messages.forbidden'))
      break
    default:
      changeFlashMessages("error", i18n.global.t('pages.common.messages.failedUpdate'))
      break
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_unref(GDialog), {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modelValue).value = $event)),
    "max-width": "30%",
    transition: "custom-from-bottom-transition",
    persistent: true
  }, {
    default: _withCtx(() => [
      _createVNode(ModalFlashMessage, {
        id: "flash-message-component",
        message: flashMessage.message,
        show: flashMessage.show,
        type: flashMessage.type,
        cancel: flashMessage.cancel,
        onSetShow: _cache[0] || (_cache[0] = (show) => {flashMessage.show = show})
      }, null, 8, ["message", "show", "type", "cancel"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, _toDisplayString(_unref(i18n).global.t('common.confirmationModal.title')), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(confirmMessage.value), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_v_btn, {
          class: _normalizeClass(["ma-2", isLoading.value ? '' : 'reset-btn']),
          style: _normalizeStyle({
          backgroundColor : isLoading.value ? '#B3B8BB' : ''
        }),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (closeModal(false))),
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.cancelBtn')), 1)
          ]),
          _: 1
        }, 8, ["class", "style", "disabled"]),
        _createVNode(_component_v_btn, {
          class: "ma-2 exec-btn",
          onClick: handleDelete,
          loading: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.exec')), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})